import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ModalPopUpTable } from './ModalPopUpTable';
import $ from 'jquery';

function TagScanModal(props) {
    var modalTitle = "Tag Scan(s)";
    var validate = false;
    const handleClose = (e) => {
        props.handleClose();
    }

    const confirmMethod = (e) => {
        var studies = []
        var txtStudy = ""

        $("td").find(".drpstudies").each(function () {
            var Study = $(this).val();

            if (Study !== "Other") {
                studies.push(Study);
            }
            else {
                txtStudy = $(this).closest("tr").find(".txtStudy").val();

                studies.push(txtStudy);
            }
        });
        let findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index)
        if (findDuplicates(studies).length > 0) {
            validate = false;
        }
        else {
            validate = true;
        }
        if (validate === true) {
            props.UpdateStudiesTimepoints();
            props.handleClose();
        }
        else {
            alert("You have selected duplicate studies")
        }
    }

    return (

        <Modal show={props.stateProps.showTagCommentModal} onHide={handleClose} style={{opacity:1}} >
            <Modal.Header closeButton>
                <Modal.Title>{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalPopUpTable scanDto={props.stateProps.scanDto} userName={props.stateProps.userName} 

                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
          </Button>
                <Button variant="primary" onClick={confirmMethod}>
                    Ok
          </Button>
            </Modal.Footer>
        </Modal>

    );
}

export default TagScanModal